import React from 'react';

const PreviewBottomSection = () => (
  <div className="public-preview-bottom">
    <div className="public-preview-bottom__inner">
      <div className="public-preview-bottom__content">
        <h2 className="public-preview-bottom__title">
          You&apos;ve seen the preview.
          <br />
          The full platform goes further.
        </h2>
        <p className="public-preview-bottom__subtitle">
          Real-time data. Complete app coverage. On tap.
        </p>
        <a
          className="btn btn-primary public-preview-bottom__cta"
          href="https://apptopia.com/en/ai-dashboard-requests"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact Us
        </a>
      </div>
      <div className="public-preview-bottom__icon public-preview-bottom__icon--lg" />
      <div className="public-preview-bottom__icon public-preview-bottom__icon--md" />
      <div className="public-preview-bottom__icon public-preview-bottom__icon--sm" />
    </div>
  </div>
);

export default PreviewBottomSection;
